module.exports = __webpack_public_path__ + "img/bg.960aea68.png";